import './CompanyStaff.css';
import Translator from '../../translates/Translator';
import { Row, Col } from 'react-bootstrap';
import teamPhotos from '../../assets/img/teamPhotos';

const CompanyStaff = () => {
    const t = Translator();

    // Radim first so he leads on mobile (stacked); order-lg-* re-centers him once
    // the row layout kicks in on desktop.
    const managers = ['radim', 'jan', 'jiri'];
    const managerOrderLg = { radim: 'order-lg-2', jan: 'order-lg-1', jiri: 'order-lg-3' };
    const employees = ['petr', 'eva', 'iva', 'bara', 'karel', 'kamila', 'jand', 'alena', 'artur', 'pavel', 'lenka'];

    return (
        <div>
            <div className='staff-managers-strip'></div>
            <div className='managers'>
                <Row>
                    {managers.map((key, i) => (
                        <Col xs={12} lg={4} key={key + i} className={managerOrderLg[key]}>
                            <Row className='mobile-manager-card'>
                                <Col xs={4} sm={3}>
                                    <div className='manager-img-wrapper'>
                                        <img src={teamPhotos[key]} alt='' />
                                    </div>
                                </Col>
                                <Col>
                                    <h4 className=''>{t(`${key}-name`)}</h4>
                                    <p className='text-notes'>{t(`${key}-position`)}</p>
                                </Col>
                                <p className='mt-3'>{t(`${key}-text`)}</p>
                            </Row>
                            <span className='desktop-manager-card'>
                                <div className='card-img-wrapper'>
                                    <div className='manager-img-wrapper'>
                                        <img src={teamPhotos[key]} alt='' className='shadow-2-6' />
                                    </div>
                                    <div className='manager-name-wrapper'>
                                        <h5 className=''>{t(`${key}-name`)}</h5>
                                        <p className='text-notes'>{t(`${key}-position`)}</p>
                                    </div>
                                </div>
                                <div className='card-description-wrapper shadow-8-2'>
                                    <Row>
                                        <Col lg={5} xl={4}>
                                            <div className='manager-small-img-wrapper'>
                                                <img src={teamPhotos[key]} alt='' />
                                            </div>
                                        </Col>
                                        <Col>
                                            <h5 className=''>{t(`${key}-name`)}</h5>
                                            <p className='text-notes'>{t(`${key}-position`)}</p>
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        <p>{t(`${key}-text`)}</p>
                                    </Row>
                                </div>
                            </span>
                        </Col>
                    ))}
                </Row>
            </div>
            <h2 className='employees-intro gray-dark'>{t("employees-intro")}</h2>
            <Row className='employees'>
                {employees.map((key, i) => (
                    <Col key={key + i} className='employee-card'
                        xs={4} sm={3} >
                        <div className='card-img-wrapper'>
                            <div className='employee-img-wrapper'>
                                <img src={teamPhotos[key]} alt='' className='shadow-2-6' />
                            </div>
                            <div className='employee-name-wrapper'>
                                <h5 className=''>{t(`${key}-name`)}</h5>
                                <p className='text-notes'>{t(`${key}-position`)}</p>
                            </div>
                        </div>
                        {/* <div className='card-description-wrapper shadow-8-2'>
                            <Row>
                                <Col lg={5} xl={4}>
                                    <div className='employee-small-img-wrapper'>
                                        <img src={teamPhotos[key]} alt='' />
                                    </div>
                                </Col>
                                <Col>
                                    <h5 className=''>{t(`${key}-name`)}</h5>
                                    <p className='text-notes'>{t(`${key}-position`)}</p>
                                </Col>
                            </Row>
                            <Row>
                                <p>{t(`${key}-text`)}</p>
                            </Row>
                        </div> */}
                    </Col>
                ))}
            </Row>
        </div>
    );
}

export default CompanyStaff;